import {Container} from "@mui/material";
import styled from "styled-components";

export const BasicContainer = styled(Container)`
    overflow: auto;
    height: 100%;
`

export const TitleContainer = styled.div`
    padding: 1.275rem 1rem;
    border-radius: 1rem;
    background: var(--common-white-main);
    margin-bottom: 1rem;
    border: 1px solid rgba(11, 69, 152, 0.1); /* TempStars Cobalt Blue with transparency */
`

export const UserContainer = styled.div`
    padding: 1.275rem 1rem;
    border-radius: var(--2, 1rem);
    background: var(--common-white-main);
    margin-bottom: 1rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`

export const NameTitle = styled.div`
    color: var(--primary-blue);
    font-feature-settings: 'clig' off, 'liga' off;

    font-size: 2.125rem;
    font-style: normal;
    font-weight: 600;
    line-height: 123.5%; /* 41.99px */
    letter-spacing: 0.25px;`

export const Title = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 0.5rem;
    font-size: 1rem;
    line-height: 1.3;
    color: var(--labels-primary);
    font-weight: 600;
    @media (min-width: 768px) {
        font-size: var(--typography-h5-size);
    }
`